module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-contract/bg.png",
      "swiper": _vm.swiper,
      "hasDownBtn": true
    }
  }, [_c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n    22年间"), _c('br'), _vm._v("您一共购买过"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.purchaseTimes))]), _vm._v("吉凯的产品或服务"), _c('br'), _vm._v("合同金额总计"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.data.amount))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n    双向奔赴的感觉真好！\n    "), _c('br'), _vm._v("\n    吉凯继续努力，提供定制化实验需求，\n    "), _c('br'), _vm._v("\n    让科研之路不再漫长\n  ")]), _vm._v(" "), _c('img', {
    staticClass: "main-text-background ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-contract/shape1.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-image-2 ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-contract/shape2.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-image-3 ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-contract/shape3.png"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04cfcb94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anniversary/PageContract/index.vue
// module id = 1524
// module chunks = 8